import React from 'react';
import { Row, Col } from 'react-bootstrap5';

import routes from 'app/routes';
import PermissionsGate from 'components/Users/PermissionsGate';
import ExternalLink from 'components/Widgets/ExternalLink';
import ManagerPolicyContext from 'contexts/ManagerPolicyContext';
import { useContext } from 'components/Managers/Programs/Context';
import Policy from './Policy';
import Templates from './Templates';

export default function Index() {
  const { state } = useContext();

  return (
    <div className="content">
      <section>
        <Row className="mb-3">
          <Col>
            <h1>Assign Programs</h1>
          </Col>

          <PermissionsGate scopes={{ 'Create Programs': ['edit'] }}>
            <Col xs="auto">
              <a href={routes.managers.templates.index} className="btn btn-primary">Manage Programs</a>
            </Col>
          </PermissionsGate>
        </Row>

        <p>
          Assign programs to your members.
        </p>
      </section>

      <section>
        <h4>Your Policy</h4>

        {state.policyEnabled ? (
          <ManagerPolicyContext enterpriseId={state.enterpriseId}>
            <Policy />
          </ManagerPolicyContext>
        ) : (
          <div className="mt-4 p-3 bg-gray-100 rounded">
            <p>
              Would you like to get the ball rolling on your Talent Insurance Program?
              Well, it all begins with creating a policy for your company.
              The LeggUP Team would be happy to help setup your policy.
              Click the button to contact us to get started!
            </p>

            <p className="mt-3 text-end">
              <ExternalLink href="https://meetings.hubspot.com/viktor-bullain">
                Contact Sales
              </ExternalLink>
            </p>
          </div>
        )}
      </section>

      <Templates />
    </div>
  );
}
